exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "i.fa-trash{\r\n    opacity: .4;\r\n    top:35px;\r\n    padding:10px;\r\n    position:absolute;\r\n    z-index:5;\r\n}\r\n\r\n.drag-over-trash{\r\n    opacity: 1 !important;\r\n    color:red;\r\n}\r\n\r\n.flow-container{\r\n    position:relative;\r\n    box-shadow: inset 0px 0px 16px rgba(0,0,0,.2);\r\n    background-color: #f4f4f4;\r\n}\r\n\r\n.node-canvas\r\n{\r\n    overflow: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    position:relative;\r\n}\r\n\r\n.bottom-right{\r\n    border-top:solid 1px rgba(0,0,0,.2);\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/git/flowdesigner/src/app/fetchdata/fetchdata.component.css
// module id = ../../../../../src/app/fetchdata/fetchdata.component.css
// module chunks = 1